<template>
<div>
    <article class="mt-5 pt-5">
      <section class="p-1">
          <h1 class="mb-3">Web Application Software Engineer</h1>
          <h3 class="mb-0 intro">Über 10 Jahre Praxis-Erfahrung in der Entwicklung von Software</h3>
      </section>
    </article>
     <vue-particles color="#dedede"></vue-particles>
    </div>
</template>

<script>
export default {
  name: 'WelcomeMain',
  props: {
    msg: String
  }
}
</script>

<style >
  #particles-js {
    /*background-image: url("./assets/sky.jpg");
    background-size: cover;*/
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    min-height: 90vh;
    /*height: 100%;
    min-height:800px;*/
    background: url('/img/radzelten-bg.jpg');
    background-size: cover;
    z-index:-20;
  }
</style>
